module.exports = __webpack_public_path__ + "static/media/chart-bar.c3a7ecb3.svg";